/**
 * .input-sm as a <select>, optionally wrapped in a labelled .form-group.
 *
 * Pass `options` as [{value, label}] or plain strings, or supply children
 * directly when option markup needs to be richer.
 */
export default function Select({ label, options, className = '', wrapperClassName = '', children, ...rest }) {
  const control = (
    <select className={['input-sm', className].filter(Boolean).join(' ')} {...rest}>
      {children ?? (options ?? []).map(o => {
        const value = typeof o === 'string' ? o : o.value;
        const text = typeof o === 'string' ? o : o.label;
        return <option key={value} value={value}>{text}</option>;
      })}
    </select>
  );

  if (!label) return control;
  return (
    <div className={['form-group', wrapperClassName].filter(Boolean).join(' ')}>
      <label>{label}</label>
      {control}
    </div>
  );
}
